
import store from "../store";
/**
 * Funcion para validar un string sea URL
 * @param text
 * @returns {boolean}
 */
export const isUrl = (text = '') => {
    let pattern = new RegExp('^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$', 'i');
    return !!pattern.test(text);
}

export const ObtenerDescuentos = (lista, suma) => {
    if(lista) {
        const results = lista.filter((element) =>  
        (element.ndt1 > 0 && element.ndt3 > 0 && suma >= element.ndt1 && suma <= element.ndt3) || 
        (element.ndt1 == 0 && element.ndt3 > 0 && suma <= element.ndt3)|| 
        (element.ndt1 > 0 && element.ndt3 == 0 && suma >= element.ndt1))
    
        if (results.length > 0) {
            const result = results[0];
    
            if (result.dt1 === 'VALOR') {
                let validarObjeto = {valor:result.ndt2, descuento: result}
                return validarObjeto;
            } else if (result.dt1 === 'PORCENTAJE'){
                let validarObjeto2 = {valor:(suma * (result.ndt2/100)).toFixed(2), descuento: result}
                return validarObjeto2
            }
        
        } else {
            let validarObjeto = {valor:0, descuento: {dt1:"",ndt4:0,ndt2:0, hash:""}}
    
            return validarObjeto; 
        }
    }else {
        let validarObjeto = {valor:0, descuento: null}
    
        return validarObjeto;
    }
    
        
};



export const ObtenerIva = (descuento,suma, iva) => {
    const descuentoTotal = suma - descuento;
    const ivaTotal = (descuentoTotal * iva)/100;
    return ivaTotal
}

export const ObtenerTotal = (iva, descuento, suma) => {
    return (suma - descuento) + iva
}

export const ObetenerSubTotal = (descuento, suma ) => {
    return (suma - descuento).toFixed(2)

}


export const ObtenerTotalAhorro = (subTotal,suma,sumaBeneficios) =>{
    return ((suma-subTotal) + sumaBeneficios).toFixed(2);
}

export const ObtenerPrecioNormal = (listaBeneficios, suma) => {
    if(listaBeneficios){
        const limpiezaInyectores = listaBeneficios.filter((item) => item.dt2.includes("LIMPIEZA INYECTORES") );
        if(limpiezaInyectores){
            var totalLimpieza = limpiezaInyectores.reduce((suma, i) => suma + i.ndt2, 0);
            var totalSuma = parseFloat(suma) + parseFloat(totalLimpieza);
            return totalSuma;
        }else{
            return suma;
        }
    }else{
        return suma;
    }
}

export const ObtenerPorcentajeAhorro = (ahorro, precioNormal) => {
    if(precioNormal > 0){
        return ((ahorro/precioNormal) *100).toFixed(0);
    }else{
        return 0;
    }
    
}

export const ObtenerTotalCompra = (total, beneficios) => {
    return total + beneficios
}